<div class="h-[92vh] p-8 relative overflow-hidden 3xl:p-12 edit-place-modal">
    <p theme border-b class="text-2xl font-bold border-b-[4px] border-green-500 pb-2">
        <span>Edit Place</span>
        <mat-icon mat-icon-button mat-dialog-close
            class="cursor-pointer absolute right-6 top-6 text-gray-400">close</mat-icon>
    </p>
    <div class="flex w-full h-full py-6">
        <div class="flex-[5] flex flex-col gap-0 h-full pr-6 overflow-y-auto w-full">
            <div class="flex justify-center items-center relative w-full">
                <ig-image [src]="place?.cover?.source" cls="rounded-xl max-h-[100%] !object-contain"
                class="max-w-[50%] w-[50%] mb-6"></ig-image>

                <div class="py-6 bg-black/60 text-white text-center semi-bold w-[50%] cursor-pointer absolute" (click)="showEditImagesModal()">Click to update images</div>
            </div>
            

            <div class="relative">
                <ig-field [control]="form.get('name')" label="Title" cls="w-full"></ig-field>
                <div class="ig-place-info-lock" (click)="lockInfo('name')"
                    matTooltip="{{place.lock&&place.lock.name?'Locked':lockTip}}">
                    <mat-icon *ngIf="!place.lock||!place.lock.name">lock_open</mat-icon>
                    <mat-icon *ngIf="place.lock&&place.lock.name">lock</mat-icon>
                </div>
            </div>

            <div class="relative mb-2">
                <!-- <ig-location-input [control]="form.get('address')" cls="w-full" class="block mobile:mb-6"
                    label="Location"
                    matTooltip="please type and select an address from the dropdown"></ig-location-input> -->
                    <ig-address-input [control]="form.get('address')" cls="w-full" class="block mobile:mb-6"
        [label]="'Location / Address *'" matTooltip="please type and select an address from the dropdown"></ig-address-input>
      <p *ngIf="!place?.lat||!place?.lng" class="text-red-500 text-sm text-left !my-1">The
        address for this place may not be accurate, or it is not a recognized Google Maps
        address. Please edit it and select from the dropdown; otherwise, the place will not be
        displayed in Map View</p>
                <div class="ig-place-info-lock" (click)="lockInfo('address')"
                    matTooltip="{{place.lock&&place.lock.address?'Locked':lockTip}}">
                    <mat-icon *ngIf="!place.lock||!place.lock.address">lock_open</mat-icon>
                    <mat-icon *ngIf="place.lock&&place.lock.address">lock</mat-icon>
                </div>
            </div>

            <ig-rich-text-box #richTextBox [description]="form.get('description').value"
                (descriptionChange)="onDescriptionChange($event)"></ig-rich-text-box>
                <ig-ai-description-generator class="mt-2 mb-4 block" [hubName]="hubName" [item]="place" 
                (onDescriptionSelected)="onAIGeneratedDescriptionSelected($event)">
              </ig-ai-description-generator>

            <div class="relative">
                <ig-field [control]="form.get('website')" label="Website" cls="w-full"></ig-field>
                <div class="ig-place-info-lock" (click)="lockInfo('website')"
                    matTooltip="{{place.lock&&place.lock.website?'Locked':lockTip}}">
                    <mat-icon *ngIf="!place.lock||!place.lock.website">lock_open</mat-icon>
                    <mat-icon *ngIf="place.lock&&place.lock.website">lock</mat-icon>
                </div>
            </div>
            <div class="relative">
                <ig-field [control]="form.get('phone')" label="Phone" cls="w-full"></ig-field>
                <div class="ig-place-info-lock" (click)="lockInfo('phone')"
                    matTooltip="{{place.lock&&place.lock.phone?'Locked':lockTip}}">
                    <mat-icon *ngIf="!place.lock||!place.lock.phone">lock_open</mat-icon>
                    <mat-icon *ngIf="place.lock&&place.lock.phone">lock</mat-icon>
                </div>
            </div>            
            <div class="relative">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Price Range</mat-label>
                    <mat-select [formControl]="form.get('priceRange')">
                        <mat-option value="1">$</mat-option>
                        <mat-option value="2">$$</mat-option>
                        <mat-option value="3">$$$</mat-option>
                        <mat-option value="4">$$$$</mat-option>
                        <mat-option value="null">N/A</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="ig-place-info-lock" (click)="lockInfo('priceRange')"
                    matTooltip="{{place.lock&&place.lock.priceRange?'Locked':lockTip}}">
                    <mat-icon *ngIf="!place.lock||!place.lock.priceRange">lock_open</mat-icon>
                    <mat-icon *ngIf="place.lock&&place.lock.priceRange">lock</mat-icon>
                </div>
            </div>
            <div class="relative">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Business Status</mat-label>
                    <mat-select [formControl]="form.get('business_status')" (selectionChange)="onBusinessStatusChange($event)"      >
                        <mat-option value="OPERATIONAL">OPERATIONAL</mat-option>
                        <mat-option value="CLOSED_TEMPORARILY">CLOSED TEMPORARILY</mat-option>
                        <mat-option value="CLOSED_PERMANENTLY">CLOSED PERMANENTLY</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="ig-place-info-lock" (click)="lockInfo('business_status')"
                    matTooltip="{{place.lock&&place.lock.business_status?'Locked':lockTip}}">
                    <mat-icon *ngIf="!place.lock||!place.lock.business_status">lock_open</mat-icon>
                    <mat-icon *ngIf="place.lock&&place.lock.business_status">lock</mat-icon>
                </div>
            </div>
            <div class="category-editor relative">
                <p class="text-base text-gray-600 !mb-1">Categories</p>
                <div class="text-sm text-gray-600">{{form.get('categoryText').value}}</div> 
                <!-- <ig-field [control]="form.get('categoryText')" label="Categories" cls="w-full" [isReadOnly]="true"
                    outline="fill"></ig-field> -->
                <div class="text-[#365899] underline !relative text-right cursor-pointer" (click)="showEditCategoryModal()">
                    Edit Category
                </div>
            </div>
            <span class="place-addition">Additional Info</span>
            <hr class="mb-4">
            <ig-field [control]="form.get('ownerEmail')" label="Email" cls="w-full"></ig-field>
            <ig-field [control]="form.get('ownerPhone')" label="Owner Phone" cls="w-full"></ig-field>
            <ig-field [control]="form.get('_360VideoKey')" label="360 Video Key" icon="video" cls="w-full"></ig-field>
            <ig-field [control]="form.get('youtubeLink')" label="YouTube Video Link" cls="w-full"></ig-field>
            <ng-container *ngIf="toggle && toggle.tour.audioTour">
                <div class="mb-7 ml-4">
                    <mat-slide-toggle [checked]="place.audio &&place.audio.isActive" (change)="toggleAudioTour()">
                        Add Audio Tour
                    </mat-slide-toggle>
                </div>

                <ig-field [hidden]="!place.audio || !place.audio.isActive" label="Audio tour link"
                    placeholder="Audio tour link" [control]="form.get('audio_link')">
                </ig-field>

                <ig-field [hidden]="!place.audio || !place.audio.isActive" label="Audio tour description"
                    placeholder="Audio tour description" [control]="form.get('audio_description')">
                </ig-field>
            </ng-container>
            <ig-field [control]="form.get('facebookLink')" label="Facebook Page Link" cls="w-full"></ig-field>
            <ig-field [control]="form.get('hostLink')" label="Place Link" cls="w-full"></ig-field>
            <div class="flex gap-2 mb-4">
                <ig-button theme class="block mb-2" [isAsync]="true" [disabled]="!form.valid"
                        (trigger)="saveChanges($event)">Save Changes</ig-button>
                    <!-- <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
                        Cancel
                    </div> -->
            </div>
        </div>
    </div>
</div>